document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.page-header-search__form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
    });
  }

  const searchPosts = () => {
    const search = document.querySelector('form.page-header-search__form #page-search');
    const primaryCategories = document.querySelector('section.sc-blog-list');
    axios
      .post(localData.apiURL, {
        action: 'searchPosts',
        s: search.value,
        primary: primaryCategories.dataset.categories || '',
        selected: [...document.querySelectorAll('.page-header__btn.is-active')].map((btn) => btn.dataset.id).join(','),
      })
      .then((response) => {
        if (response.status === 200) {
          document.querySelector('.blog-list__items').innerHTML = response.data.data.html;
        }
      });
  };
  const searchField = document.querySelector('form.page-header-search__form #page-search');
  if (searchField) {
    searchField.addEventListener(
      'keyup',
      debounce(() => {
        searchPosts();
      }, 200),
    );
  }
});
